import { createContext } from "react";
import { TUserContext } from "@userContext";

const UserContext = createContext<TUserContext>({} as TUserContext);

export default UserContext;
